import { useState, useEffect } from "react";
import { Input } from "reactstrap";

const FolderEditor = ({ onChange, resetData, setResetData }) => {
  const [title, setTitle] = useState("");

  const handleTitleChange = (e) => {
    setTitle(e.target.value);
    onChange({
      Type: "Group",
      Title: e.target.value,
      Items: [],
    });
  };

  useEffect(() => {
    if (resetData === true) {
      setTitle("");
      setResetData(false);
    }
  }, [resetData, setResetData]);

  return (
    <>
      <div className="p-2">
        <h5 style={{ width: 100, paddingTop: 10 }}>Name</h5>
        <Input
          value={title}
          placeholder="Folder Name"
          onChange={handleTitleChange}
        />
      </div>
    </>
  );
};

export default FolderEditor;
